import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Table} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class Response extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.props.toggleCreatedDealerEmergingOrder();
  }

  render() {
    const {isOpen, createdOrder} = this.props;

    return (
      <Modal closeIcon
        size='small'
        trigger={<span />}
        open={isOpen}
        onClose={this.handleClose}
      >
        <Modal.Content className='dealer-emerging-order-modal'>
          <h2>Pedido creado con éxito</h2>
          El pedido emergente se creo exitosamente con el número
          <h2>{createdOrder.orderCode}</h2>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Solicitado</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Despachar Principal</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Tránsito Principal</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Cancelado</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign='right'>{createdOrder.order}</Table.Cell>
                <Table.Cell textAlign='right'>{createdOrder.reservedStock}</Table.Cell>
                <Table.Cell textAlign='right'>{createdOrder.reservedTransit}</Table.Cell>
                <Table.Cell textAlign='right'>{createdOrder.notAttended}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'isOpen': state.dealerEmergingOrders.wasCreated,
    'createdOrder': state.dealerEmergingOrders.createdOrder || {},
  };
};

const {toggleCreatedDealerEmergingOrder} = Actions;

export default connect(mapStateToProps, {
  toggleCreatedDealerEmergingOrder,
})(Response);
